import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["tendlc_nightmare_why_its_taking_weeks_to_get_approved"] */ "/vercel/path0/lib/article-content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
